<div class="modal-header border-success">
  <h4 class="modal-title text-primary">Add device</h4>
  <button type="button"
          class="btn-close"
          aria-label="Close"
          (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <era-pairing-request></era-pairing-request>
</div>